import { render, staticRenderFns } from "./AcButton.vue?vue&type=template&id=49708487"
import script from "./AcButton.vue?vue&type=script&lang=js"
export * from "./AcButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./admin/src/js/components/AcButton.vue
// module id = 18
// module chunks = 0